import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
// import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import moment from 'moment'
// import x5GMaps from 'x5-gmaps'

// Option 1: Just your key
// Vue.use(x5GMaps, 'AIzaSyCL9p8cFen1ec-TZRTjwG49Rz8HXKB_Nww')
// Option 2: With libraries
// Vue.use(x5GMaps, { key: 'YOUR_GOOGLE_KEY', libraries: ['places'] })

// axios.defaults.baseURL = 'http://dummy.restapiexample.com/api/v1'
axios.defaults.baseURL = 'http://admin.kensrin.co.ke/ntsa'

axios.interceptors.request.use(function (config) {
    var tk =  sessionStorage.getItem('vuex');  
    
    if(tk!=null){  
      // config.headers['Authorization'] = 'Bearer ' + JSON.parse(tk).session.token
    } 
    return config
  }, function (error) {
    return Promise.reject(error)
  })

axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger  
    return response
  }, function (error) {
    return Promise.reject(error)
  })

Vue.prototype.$http = axios
Vue.config.productionTip = false

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')

router.beforeEach((to, from, next) => { 
  if (to.path === '/logout') {
    store.dispatch('logout')
    next('/')
  } else {
    if(to.matched.some(record => record.meta.requiresAuth)){
      if (store.getters.isLoggedIn) {
        var c = '/'+ to.path.split('/')[1].toString() +(!to.path.split('/')[2] ? "" : '/'+ to.path.split('/')[2].toString()); 
          
        if(store.state.session){  
            var menuItems = store.state.session.menuItems; 
            var pexists = menuItems.some(menu => menu.to.includes(to.path))
              if (pexists)
                next();
              else
                next('/'); 
        } else 
         next('/')
      } else
         next('/')
    } else 
        next()
  }
})
